const {jQuery: $} = window;
import Utils from "./utils.class";
import Cookies from 'js-cookie';
import Swiper from 'swiper/bundle';
import {iframeResize} from "iframe-resizer"

// import  '../lib/mmenu';
import './constellation'; //Need to uncomment to enable.

export default class Theme {
    $main;
    #html;
    #body;
    #header;
    #firstElement;
    #builder;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #utils;
    #admin;
    #root;
    #cmp;

    #counter;
    #topHeader;

    constructor(
        config,
        builder,
        utils,
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.#html = $('html');

        this.#body = $('body');
        this.$main = $('.site-wrapper');
        this.#header = $('header.elementor-location-header');
        this.#firstElement = $('header + div.elementor > div.elementor-element');
        this.#admin = $('#wpadminbar');
        this.#counter = $('.counter__number');
        this.#topHeader = $('.headerTop');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        document.addEventListener("cookieyes_consent_update", (eventData) =>
        {
            Utils.log("Consent Data:", eventData);

            eventData.detail.accepted.forEach( (category) => {
                category = category === 'advertisement' ? 'marketing' : category;
                if(wp_set_consent) wp_set_consent(category, "allow");
                this.#body.removeClass(`cmp-${category}--deny`).addClass(`cmp-${category}--allow`);
            });

            eventData.detail.rejected.forEach((category) => {
                category = category === 'advertisement' ? 'marketing' : category;
                if(wp_set_consent) wp_set_consent(category, "deny");
                this.#body.removeClass(`cmp-${category}--allow`).addClass(`cmp-${category}--deny`);
            });

            if(eventData.detail.accepted.includes("advertisement")) {
                $(".pardot-form.js--awaiting-consent").each(function (i, el) {
                    const $el = $(el);
                    const src = $el.attr("data-src");
                    $el.attr("src", src).removeClass("js--awaiting-consent");
                });
            }
        });

        document.addEventListener("cookieyes_banner_load", (eventData) => {
            const detail = eventData.detail;

            Utils.log("Consent Data:", detail);

            if(detail.activeLaw === 'gdpr') {
                window.wp_consent_type = "optin";
            } else {
                window.wp_consent_type = "optout";
            }

            for (let cat in detail.categories) {
                let name = cat === 'advertisement' ? 'marketing' : cat;

                if(detail.categories[cat]) {
                    if(wp_set_consent) wp_set_consent(name, "allow");
                    this.#body.removeClass(`cmp-${name}--deny`).addClass(`cmp-${name}--allow`);
                } else {
                    if(wp_set_consent) wp_set_consent(name, "deny");
                    this.#body.removeClass(`cmp-${name}--allow`).addClass(`cmp-${name}--deny`);
                }
            }

            if(detail.categories.advertisement) {
                $(".pardot-form.js--awaiting-consent").each(function (i, el) {
                    const $el = $(el);
                    const src = $el.attr("data-src");
                    $el.attr("src", src).removeClass("js--awaiting-consent");
                });
            }
        });
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        $('a').each(function (i, el) {
            var url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if (url) {
                if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                    var id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1");

                    $(el).featherlight();
                }
            }
        });

        const slider = new Swiper('.resource--slider', {
            speed: 400,
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });

        const ftBlogSlider = new Swiper('.blog--slider', {
            speed: 400,
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });

        const blogSlider = new Swiper('.feature-post--slider', {
            speed: 400,
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });

        $(".imageMap__singleButton").hover(
            function () {
                if ($(window).width() > 780) {
                    let imageID = '#' + $(this).attr('data-image');
                    $(".imageMap__buttons").children().removeClass('hover');
                    $(".imageMap__maps").children().removeClass('hover');
                    $(this).addClass("hover");
                    $(imageID).addClass("hover");
                }
            }, function () {
                let imageID = '#' + $(this).attr('data-image')
                $(this).removeClass("hover");
                $(imageID).removeClass("hover");
            }
        );

        $(".wistia_embed").on('click', function () {
            $('.wistia_popover_overlay').appendTo($('#site-wrapper'));
        })

        // Link to Pardot iframes
        $(".pardot-form").each((i, el) => {
            this.#loadForm(el);
        });

        $(document).on('elementor/popup/show', (event, id, instance) => {
            instance.$element.find(".pardot-form").each((i, el) => {
                const $el = $(el);
                this.#loadForm(el);

                if(wp_has_consent && wp_has_consent("marketing")) {
                    const src = $el.attr("data-src");
                    $el.attr("src", src).removeClass("js--awaiting-consent");
                }

                $el.find('.js--hide-while-loading').removeClass('js--hide-while-loading');

                iframeResize({log: Utils.debug, scrolling: false, checkOrigin: false}, el);
            });
        });

        setTimeout(function () {
            const frame = iframeResize({log: Utils.debug, scrolling: false, checkOrigin: false}, ".resource--form__embed iframe, .embedded-form iframe");
            setInterval(frame.resize, 1000);
        }, 1);

        let pardotLeadCheck = false;
        window.addEventListener("message", function (event) {
            if (event.origin !== "https://www2.ctera.com") return;

            let message = false;
            try {
                message = JSON.parse(event.data);
            } catch (e) {}

            if (!pardotLeadCheck && message && (message.type === "pardot-form-submitted")) {
                window.dataLayer = dataLayer || [];
                pardotLeadCheck = true;

                setTimeout(() => pardotLeadCheck = false, 10000); // throttle duplicate messages from the same form, not sure why this happens.

                const utm_campaign = Utils.URLSearchParams.get('utm_campaign');
                const utm_source = Utils.URLSearchParams.get('utm_source');
                const utm_medium = Utils.URLSearchParams.get('utm_medium');
                const utm_term = Utils.URLSearchParams.get('utm_term');
                const utm_content = Utils.URLSearchParams.get('utm_content');
                const utm_id = Utils.URLSearchParams.get('utm_id');
                const resourceID = message.data.resourceID || 0;
                const email = message.data.email || "";
                const $resourceForm = $(`<form[data-resource='${resourceID}']`);

                const eventData = {
                    event: 'pardotLead',
                    pardotLead: {
                        pageURL: window.location.origin + window.location.pathname,
                        utm_campaign: utm_campaign || "",
                        utm_source: utm_source || "",
                        utm_medium: utm_medium || "",
                        utm_term: utm_term || "",
                        utm_content: utm_content || "",
                        utm_id: utm_id || ""
                    },
                };

                Utils.log("GTM Event: ", eventData);

                dataLayer.push(eventData);

                if(window.kmdgResourceCenter && resourceID !== 0 && $resourceForm.length > 0) {
                    window.kmdgResourceCenter.resource = resourceID;
                    $(window).trigger('kmdg_rc_form_submitted', [email, null, function (response) {
                        // Generate thank you page
                        Utils.log("[RC] Download:", response);

                        $resourceForm.next('.kmdg-resource-center').find(`#download`).html(response);
                        window.location.hash = "download";
                    }]);
                }
            }
        });

        $('.js--hide-while-loading').removeClass('js--hide-while-loading');
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#admin = $('#wpadminbar');

        // me.#slider.show();

        Utils.equalHeight('.image_callout__text', '.builder-layout');
        Utils.equalHeight('.graphic_card__text', '.builder-layout');
        Utils.equalHeight('.carouselSpotlight__slide', '.carouselSpotlight');
        Utils.equalHeight('.elementor-element.e-child.e-con-full', '.e-n-tabs-content');
        // Utils.equalHeight('.e-child', '.e-n-tabs-content');
        Utils.equalHeight('.tabbed_section__js', '.tabbed_section');
        Utils.equalHeight('.rollover-height', '.builder-section-type--rollover');

        // this.#TabsLayout.init();

        $(window).trigger("resize");

        Utils.equalHeight('.js-equalizer-logo', '.logo-slider-container');
        // Utils.equalHeight('.pdfemb-the-canvas', '.resource--main-content');

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        $('.single_accordion .single_accordion__header').on('click', function () {
            var $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.single_accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        var top = 1; // Trigger on any scrolling
        $(document).scroll(function () {
            var scrollPos = $(document).scrollTop();
            if (top && scrollPos >= top) {
                $('.elementor-location-header').addClass('scrollHide');
            } else if (top && scrollPos < top) {
                $('.elementor-location-header').removeClass('scrollHide');
            }
        });

        var menu = new window.Mmenu("#menu-wrapper", {
            "offCanvas": {
                "position": "right-front",
            },
            "theme": "dark",
        }, {
            "offCanvas": {
                "page": {
                    "selector": "#site-wrapper"
                }
            }
        });

        $('.mmenu-nav').on('click', function (evnt) {
            evnt.preventDefault();
            menu.API.open()
        })

        $('.comeetCareers__locationFilter').on('click', function () {
            var filter = $(this).data('location');
            var loop = $('.comeetCareers__list').children();
            loop.each(function (el) {
                $(this).removeClass('hidden');
                if (!$(this).hasClass(filter)) {
                    $(this).addClass('hidden')
                }
            })
        });

        $('.comeetCareers__button').on('click', function () {
            $('.comeetCareers__list').children().each(function () {
                $(this).removeClass('hidden')
            });
        });

        $(document).on("gform_confirmation_loaded", function (e, form_id) {
            Utils.log("[RC] Confirmation Loaded:", form_id);

            if (kmdgResourceCenter.form == form_id) {

                $(window).trigger('kmdg_rc_form_submitted', [$(`#gform_${form_id}`).find("input[type=email]").val(), form_id, function (response) {
                    // Generate thank you page
                    Utils.log("[RC] Download:", response);

                    $(`#gform_confirmation_message_${form_id}`).html(response);
                    window.location.hash = "download";
                }]);
            }
        });

        $('.bingsearchbutton').on('click', function () {
            $('#bingsearchcontainer').toggleClass('showSearch')
        });

        $(document).on('click', '#searchOverlay', function (e) {
            $('#bingsearchcontainer').toggleClass('showSearch')
        });
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    #loadForm(el) {
        const $el = $(el);
        const campaign = encodeURI(Utils.URLSearchParams.get("utm_campaign") || "");
        const source = encodeURI(Utils.URLSearchParams.get("utm_source") || "");
        const medium = encodeURI(Utils.URLSearchParams.get("utm_medium") || "");
        const term = encodeURI(Utils.URLSearchParams.get("utm_term") || "");
        const content = encodeURI(Utils.URLSearchParams.get("utm_content") || "");
        const prefix = $el.data("url").includes("?") ? "&" : "?";
        const url = $el.data("url") + `${prefix}utm_campaign=${campaign}&utm_source=${source}&utm_medium=${medium}&utm_content=${content}&utm_term=${term}`;

        $el.attr("data-src", url);

        $el.removeClass("loading");
    }

    optIn(type) {
        const types = {
            "analytics": "ckySwitchanalytics",
            "marketing": "ckySwitchadvertisement",
            "functional": "ckySwitchfunctional",
            "performance": "ckySwitchperformance",
            "other": "ckySwitchother"
        }

        Utils.log("Opt In:", type);

        if(wp_set_consent) {
            wp_set_consent(type, "allowed");
        }

        if(document.getElementById(types[type])) {
            document.getElementById(types[type]).checked = true;
            performBannerAction("accept_partial");
        }
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#admin.length > 0) {
            return this.#header.outerHeight() + this.#admin.outerHeight();
        }

        return this.#header.outerHeight();
    }

    get CMP() {
        return this.#cmp;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}